import {State, Module} from '../decorators.js';
import BaseRoute from '../routing';
import ReactModule from '../react/react';

/**
 * Demo route proving the React island renders inside the AngularJS shell,
 * AND that state flows both ways:
 *   - Angular -> React via the `props` binding on the `react-view` directive.
 *   - The shared store (synced with the real logged-in user by InitService, on both initial page load and login) is read by BOTH React (`useStore`) and Angular
 */
class Ctrl {
    constructor(ReactBridge) {
        "ngInject";
        this.ReactBridge = ReactBridge;
        // Pass data from Angular into the React component as props.
        this.reactProps = {title: 'Hello from React'};
    }

    // Read directly from the shared vanilla Zustand store on the Angular side.
    // The `app.react` module's `.run()` connector calls `$rootScope.$applyAsync()`
    // whenever the store changes, which re-triggers Angular's digest and
    // re-evaluates this getter in the template — no manual subscription needed.
    storeUser() {
        return this.ReactBridge().store.getState().currentUser;
    }
}

@Module({
    name: 'app.react_demo',
    modules: [
        BaseRoute,
        ReactModule,
    ],
})
@State({
    name: 'r.in.top.react_demo',
    url: '/react-demo',
    controller: Ctrl,
    template: `
        <div class="container" style="padding-top: 20px;">
            <div react-view="hello" props="vm.reactProps"></div>
        </div>
    `,
    ncyBreadcrumb: {
        label: 'React Demo',
    },
})
export default class States {
}



// WEBPACK FOOTER //
// ./src/app/react/routing.js